import { GuestShoppingItemsData } from '../../providers/guest-shopping-items-data';
import { GuestRecipeBoxData } from '../../../recipes/providers/guest-recipe-box-data';
import { Component } from '@angular/core';
import { NavController,  Events, App } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { PageBase } from '../../../../core/page-base';
import { LoginPage } from '../login/login';
import { AppSettings } from '../../../../config/app-settings';
import { AccountCommon } from './account.common';

@Component({
	selector: 'page-account',
  	templateUrl: 'account.html'
})

export class AccountPage extends PageBase {
	
	public currentUser: any;
	public useremail: string;
	public nameInitials: string;
	public modal: any;

	constructor(
		public nav: NavController,
		public app: App,
		public userData: UserData,
		public common: AccountCommon,
		public events: Events,
		public settings: AppSettings,
		public guestRecipeBoxData: GuestRecipeBoxData,
		public guestShoppingItemsData:GuestShoppingItemsData
	) {
		super(settings, events, nav, userData);
		console.log("Loading Account Mobile");
	}

	ionViewDidEnter() {
		this.app.setTitle('My Account');
	}

	ngAfterViewInit() {
		let self = this;

		self.userData.hasLoggedIn().subscribe((isLoggedIn) => {
			if(isLoggedIn){
				self.common.loadUserData(this.nav);
			}
			else{
				self.nav.setRoot(LoginPage);
			}
		});
	}

	signOut(){
		this.common.signOut(this.nav);
		this.guestRecipeBoxData.cleanData();
		this.guestShoppingItemsData.cleanData();
	}


	
}



// WEBPACK FOOTER //
// ./src/modules/account/pages/account/account.ts